import React, { useCallback } from "react";
import Logo from "../header/logo/Logo";
import FindGame from "../find_game/FindGame";
import "./aside-menu.scss";
import MenuProviders from "./menu_providers/MenuProviders";
import IconClip from "../../mui/JSXIcons/IconClip";
import { useTranslation } from "react-i18next";
import IconTg from "../../mui/JSXIcons/IconTg";
import IconSupport from "../../mui/JSXIcons/IconSupport";
import BonusBannerMenu from "./bonus_menu/BonusBannerMenu";
import ShowContainer from "../../mui/ShowContainer";
import { useAppSelector } from "../../../store/index.ts";
import ErrorBoundary from "../../mui/error_boundary/ErrorBoundary.jsx";
import { useReadLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME } from "../../../store/enums.js";
import { setOpenMenu } from "../../../store/siteSlice.js";
import { useDispatch } from "react-redux";
import TgWidgetContainer from "./TgWidgetContainer.jsx";

export default function AsideMenu({ className = "", showLogo = true }) {
  const { t } = useTranslation();
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";
  const dispatch = useDispatch();

  const botName = useAppSelector((state) => state.common.botName);
  const supportChat = useAppSelector((state) => state.links.supportChat);
  const openMenu = useAppSelector((state) => state.site.openMenu);
  const isMenuAbsolute = useAppSelector((state) => state.deviceSize.isMenuAbsolute);
  const channelUrl = useAppSelector((state) => state.links.channelUrl);
  const tgPostUrl = useAppSelector((state) => state.links.tgPostUrl);
  const pageWitchMenuHeight = useAppSelector((state) => state.site.pageWitchMenuHeight);
  const isIos = useAppSelector((state) => state.deviceSize.isIos);
  const isWebApps = useAppSelector((state) => state.deviceSize.isWebApps);

  const isDark = true;
  const tgCasinoLink = start_r
    ? `https://t.me/${botName}?start_r=${start_r}`
    : "https://t.me/${botName}";

  const tgSupportLink = start_r
    ? `https://t.me/${supportChat}?start_r=${start_r}`
    : `https://t.me/${supportChat}`;

  const handleBackgroundClick = useCallback(() => dispatch(setOpenMenu(false)), [dispatch]);

  const openClass = openMenu ? "open" : "";
  const absoluteClass = isMenuAbsolute ? "fixed" : "";

  const asideStyle =
    pageWitchMenuHeight > 0 ? { "--aside-max-h": `${pageWitchMenuHeight}px` } : undefined;

  return (
    <>
      <ShowContainer condition={isMenuAbsolute && openMenu}>
        <div className="aside-menu aside-menu__plug"></div>
      </ShowContainer>

      <aside className={`aside-menu ${className} ${openClass} ${absoluteClass}`} style={asideStyle}>
        <Logo showOpenMenu={true} showLogo={showLogo} />

        {/* ref убран — измерять нечего */}
        <div className="aside-menu__menu">
          <div className="menu-content">
            <ErrorBoundary>
              <BonusBannerMenu />
            </ErrorBoundary>

            <ErrorBoundary>
              <FindGame inputId="aside__find-game" />
            </ErrorBoundary>

            <ErrorBoundary>
              <MenuProviders />
            </ErrorBoundary>

            <ShowContainer condition={!!(botName || supportChat)}>
              <div className="menu__other">
                <h2>
                  <IconClip /> {t("Other")}
                </h2>
                <div>
                  <ShowContainer condition={!!botName}>
                    <a
                      className="menu__other__item"
                      aria-label={t("Telegram Casino")}
                      href={tgCasinoLink}
                      target="_blank"
                      rel="noreferrer">
                      <IconTg />
                      <span className="menu__other__item__title">{t("Telegram Casino")}</span>
                    </a>
                  </ShowContainer>

                  <ShowContainer condition={!!supportChat}>
                    <a
                      className="menu__other__item"
                      aria-label={t("Support")}
                      href={tgSupportLink}
                      target="_blank"
                      rel="noreferrer">
                      <IconSupport />
                      <span className="menu__other__item__title">{t("Support")}</span>
                    </a>
                  </ShowContainer>
                </div>
              </div>
            </ShowContainer>
          </div>

          <ShowContainer condition={!!channelUrl}>
            <a
              href={channelUrl}
              target="_blank"
              rel="noreferrer"
              className="tg-group"
              style={{ background: isDark ? "#121212" : undefined }}>
              {t("Telegram group")}
            </a>
          </ShowContainer>

          <ShowContainer condition={!!(tgPostUrl && !(isIos && isWebApps))}>
            <ErrorBoundary>
              <TgWidgetContainer />
            </ErrorBoundary>
          </ShowContainer>
        </div>
      </aside>

      <ShowContainer condition={openMenu && isMenuAbsolute}>
        <div className="aside-menu--bg" onClick={handleBackgroundClick} />
      </ShowContainer>
    </>
  );
}
